/**
 * Klick auf die Overlay-Fläche schliesst das Menü.
 *
 * Der Entwurf schliesst auf drei Wegen: über das × oben rechts, über einen
 * Klick auf die freie Fläche und über einen Menülink (`index.html:1234`):
 *
 *   o.addEventListener('click', e => {
 *     if (!e.target.closest('a,.mn-toggle,.menu-close')) close();
 *   });
 *
 * ⚠️ Warum das nicht in CSS geht: Horizon hängt seinen Schliess-Handler an
 * `.menu-drawer__backdrop` (`snippets/header-drawer.liquid:776`). Der liegt auf
 * `--layer-overlay` (16), unser Vollflächen-Overlay auf `--layer-menu-drawer`
 * (18) darüber — es gibt kein „daneben" mehr. Den Backdrop höherzulegen ist
 * keine Lösung: Dann läge er über den Menülinks und machte sie unbedienbar.
 *
 * Deshalb hier, und bewusst NICHT in `snippets/header-drawer.liquid` — das ist
 * eine Horizon-Kerndatei, und jeder Eingriff dort muss ein Update überleben.
 * Diese Datei kostet keinen.
 */

/**
 * Elemente, die selbst etwas tun und deshalb nicht schliessen dürfen.
 *
 * ⚠️ `details` gehört NICHT in diese Liste: Das ganze Overlay steckt in einem
 * `<details>`, ein `closest('details')` träfe damit immer — und es würde nie
 * geschlossen. Die Untermenüs sind über ihr `summary` abgedeckt.
 */
const INTERACTIVE = 'a, button, summary, input, select, textarea, label, [role="button"]';

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  // Nur im Menü-Overlay. Der Warenkorb-Drawer bringt sein eigenes
  // Light-Dismiss mit (`<dialog>`), das hier nicht gestört werden darf.
  const panel = target.closest('.menu-drawer');
  if (!panel) return;

  if (target.closest(INTERACTIVE)) return;

  panel.closest('header-drawer')?.close();
});
